import { appIcon, dgIcon, gridIcon, notificationIcon, notificationIcon2, notificationPlaceholder, solarIcon } from "assets/icons";
import Placeholder from "components/placeholder/Placeholder";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { GoDotFill } from "react-icons/go";
import InfiniteScroll from "react-infinite-scroll-component";
import { getNotificationApi } from "services/notification";
import { failMessage } from "utils/toastMessage";

const NotificationDropDown = () => {
  const [notificationList, setNotificationList] = useState([])
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  // --------handle-icon------------------
  const handleIcon = (iconName) => {
    switch (iconName) {
      case "grid":
        return <img src={gridIcon} alt="Grid Icon" />;
      case "dg":
        return <img src={dgIcon} alt="DG Icon" />;
      case "solar":
        return <img src={solarIcon} alt="Solar Icon" />;
      default:
        return <img src={appIcon} alt="App Icon" />;
    }
  };

  //--------notification-listing--------------
  const getNotification = async (page = 1, isRefresh = false) => {
    try {
      setLoading(true)
      const payload = {
        limit: 10,
        page,
      }
      const res = await getNotificationApi(payload)
      if (res?.status === 200) {
        const data = res?.data?.list
        const totalCount = res?.data?.total || 0;
        if (isRefresh) {
          setNotificationList(data || []);
        } else {
          setNotificationList((prev) => [...prev, ...(data || [])]);
        }
        const newLength = (isRefresh ? data.length : notificationList.length + data.length);
        setHasMore(newLength < totalCount);
      } else {
        failMessage(res)
      }
    } catch (e) {
      console.log('error', e?.message)
    } finally {
      setLoading(false)
    }
  }


  useEffect(() => {
    setPage(1);
    setHasMore(true);
    getNotification(1, true);
  }, []);

  const fetchMoreData = () => {
    if (!hasMore) return;
    const nextPage = page + 1;
    setPage(nextPage);
    getNotification(nextPage);
  };
  return (
    <>
      <Dropdown className="custom_dropdown notification">

        <Dropdown.Toggle variant="success" id="dropdown-basic">
          <img src={notificationIcon} alt="notification" />
          <GoDotFill className="blink" />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {/* <p className="date">Today</p> */}
          <div className="wrap_noti_scroll">
            {(!loading && notificationList.length === 0) ? (
              <Placeholder image={notificationPlaceholder} title={"No  data found"} />
            ) : (
              <InfiniteScroll
                dataLength={notificationList.length}
                next={fetchMoreData}
                hasMore={hasMore}
              >
                {notificationList.length > 0 && notificationList.map((data, ind) => {
                  return (
                    <Dropdown.Item as={"div"} key={ind}>
                      {handleIcon(data?.actionType)}
                      <p>
                        <b>{data?.title || "N/A"}</b>
                        <span>{data?.message || "N/A"}</span>
                        <small>{moment(data?.createdAt).fromNow() || "N/A"}</small>
                      </p>
                    </Dropdown.Item>
                  )
                })}

              </InfiniteScroll>)}
          </div>


        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default NotificationDropDown;
